import { render, staticRenderFns } from "./ContactColumn.vue?vue&type=template&id=7527fa69&"
import script from "./ContactColumn.vue?vue&type=script&lang=js&"
export * from "./ContactColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports